import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M14 7.006c0 1.861-.838 3.738-2.05 4.95s-3.089 2.05-4.95 2.05-3.738-.838-4.95-2.05S0 8.867 0 7.006s.838-3.738 2.05-4.95S5.139.006 7 .006s3.738.838 4.95 2.05S14 5.145 14 7.006M10.536 3.47C9.576 2.511 8.453 2.006 7 2.006s-2.576.505-3.536 1.464C2.505 4.43 2 5.553 2 7.006s.505 2.576 1.464 3.536c.96.959 2.083 1.464 3.536 1.464s2.576-.505 3.536-1.464C11.495 9.582 12 8.459 12 7.006s-.505-2.576-1.464-3.536"
    }, null, -1)
  ]))]))
}
export default { render: render }